<template>
  <div class="result_wrap">
    <div class="container">
      <div class="header">
        <p>{{vcResultInfo.reqIdC}}</p>
        <div @click="backlist">
          <img src="../assets/image/Vcar_result/back_pack.png">
          <p>列表</p>
        </div>
      </div>
      <div class="main">
        <div class="main-top">
          <div>
            <p>寻车需求</p>
            <div><p>{{vcResultInfo.reqTimeC}}</p></div>
          </div>
          <div class="status-sign"></div>
          <div class="vcar-require">
            <div>
              <div class="item">
                <p class="caption">品牌</p>
                <p class="content">{{vcResultInfo.reqBrandC}}</p>
              </div>
              <div class="item">
                <p class="caption">车系</p>
                <p class="content">{{vcResultInfo.reqVehSeriesC}}</p>
              </div>
              <div class="item">
                <p class="caption">车型</p>
                <p class="content">{{vcResultInfo.reqVehTypeC}}  {{vcResultInfo.reqVehMsrpC != null? '指导价 '+ vcResultInfo.reqVehMsrpC:''}}</p>
              </div>
              <div class="item">
                <p class="caption">颜色</p>
                <p class="content">{{vcResultInfo.reqVehXcolorC}}</p>
              </div>
              <div class="item">
                <p class="caption">省份</p>
                <p class="content">{{vcResultInfo.reqProvinceC}}</p>
              </div>
              <div class="item">
                <p class="caption">城市</p>
                <p class="content">{{vcResultInfo.reqVehCityC}}</p>
              </div>
              <div class="item">
                <p class="caption">备注</p>
                <p class="content">{{vcResultInfo.reqVehNoteC}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="main-bottom">
          <div>
            <p>寻车结果</p>
            <div v-if="vcResultInfo.rstTimeC != null">
              <p>{{vcResultInfo.rstVmtypeC}}</p>
              <p>{{vcResultInfo.rstTimeC}}</p>
            </div>
          </div>
          <div class="vcar-ing" v-if="vcResultInfo.rstTimeC == null">
            <img src="../assets/image/Vcar_result/loding.png">
            <p>正在寻车中</p>
          </div>
          <div class="vcar-success" v-if="vcResultInfo.rstTimeC != null">
            <div class="vcar-data-1">
              <div class="item">
                <p>优惠</p>
                <p>{{vcResultInfo.rstDiscountC!=null&&vcResultInfo.rstDiscountC!=''?vcResultInfo.rstDiscountC+'元':''}}</p>
              </div>
              <div class="item">
                <p>价格</p>
                <p>{{vcResultInfo.rstPriceC!=null&&vcResultInfo.rstPriceC!=''?vcResultInfo.rstPriceC+'元':''}}</p>
              </div>
              <div class="item">
                <p>颜色</p>
                <p>{{vcResultInfo.rstXcolorC}}</p>
              </div>
              <div class="item">
                <p>城市</p>
                <p>{{vcResultInfo.rstCityC}}</p>
              </div>
              <div class="item">
                <p>备注</p>
                <pre>{{vcResultInfo.description}}</pre>
              </div>
            </div>
            <div class="vcar-time-consuming">
              <p>耗时 {{vcResultInfo.rstElapsedC}}</p>
            </div>
            <div class="vcar-data-2">
              <div class="item">
                <p>发票要求</p>
                <p>{{vcResultInfo.rstInvoicestatusC}}</p>
              </div>
              <div class="item">
                <p>保险要求</p>
                <p>{{vcResultInfo.rstInsurancetypeC}}</p>
              </div>
              <div class="item">
                <p>额外服务</p>
                <p>{{vcResultInfo.rstExtraserviceC}}</p>
              </div>
              <div class="item">
                <p>额外杂费</p>
                <p>{{vcResultInfo.rstDealerfeeC!=null&&vcResultInfo.rstDealerfeeC!=''?vcResultInfo.rstDealerfeeC + '元':''}}</p>
              </div>
              <div class="item">
                <p>预付定金</p>
                <p>{{vcResultInfo.rstPrepaiddepositC!=null&&vcResultInfo.rstPrepaiddepositC!=''?vcResultInfo.rstPrepaiddepositC + '元':''}}</p>
              </div>
              <div class="item">
                <p>车辆位置</p>
                <p>{{vcResultInfo.rstVehPositionC}}</p>
              </div>
              <div class="item">
                <p>到车周期</p>
                <p>{{vcResultInfo.rstLogisticetaC}}</p>
              </div>
              <div class="item">
                <p>合格证</p>
                <p>{{vcResultInfo.rstVqcstatusC}}</p>
              </div>
              <div class="item">
                <p>车源商名称</p>
                <p>{{vcResultInfo.rstDealernameC}}</p>
              </div>
              <div class="item item-2">
                <p>车源商联络人</p>
                <p>{{vcResultInfo.rstDealerliaisonC}}</p>
              </div>
              <div class="item item-2">
                <p>车源商地址</p>
                <p>{{vcResultInfo.rstDealeraddressC}}</p>
              </div>
              <div class="item item-2">
                <p>车源商联络人电话</p>
                <p>{{vcResultInfo.rstDealerliaisonmobileC}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Toast } from 'mint-ui';
  import qs from 'qs'
  import commons from '../utils/common'
  import  constants from '../utils/constants'
    export default {
        name: "Vcar_Result",
      data(){
        return {
          vcOrderId: '',
          vcSuccessFlag: true,
          vcResultInfo: NaN
        }
      },
      created(){
      },
      computed: {
      },
      mounted(){
        if(commons.isEmpty(sessionStorage.getItem("mobile"))){
          if(commons.isEmpty(sessionStorage.getItem("id"))) {
            commons.redirect(this, 'vcar_list')
            return
          }
          commons.redirect(this, 'vcar_login')
        }
        window.scrollTo(0, 0)
        const that = this
        that.$nextTick(function () {
          // 获取列表信息
          let data = {"id": sessionStorage.getItem("id")}
          that.$axios.post('/marketing/vhvm/result', qs.stringify(data)).then(function (res) {
            that.vcResultInfo = res.data.data
          }).catch(function (error) {
            commons.tipToast(error.data.msg)
            return
          });
          commons.wxShare(that, constants.VC_SHAREINFO)
        })
      },
      methods: {
        backlist() {
          commons.redirect(this, 'vcar_list')
        }
      }
    }
</script>

<style scoped>
  p,div,sup,pre {
    font-family: "PingFang SC";
  }

  #result_wrap {
    width: 100vw;
    background-color: #fff;
  }

  .container {
    margin: 0 auto;
    width: 7.5rem;
    /*overflow: hidden;*/
  }

  #result_wrap > .container {
    margin: 0 auto;
    width: 7.5rem;
  }

  .container > .header {
    margin: 0 auto;
    margin-top: 0.26rem;
    width: 6.74rem;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
  }

  .container > .header > p {
    margin: 0;
    font-size: 0.3rem;
    line-height: 0.42rem;
    color: #000000;
    letter-spacing: -0px;
  }
  .container > .header > div {
    font-size: 0;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  }
  .container > .header > div > img {
    height: 0.22rem;
  }

  .container > .header > div > p {
    margin: 0;
    margin-left: 0.16rem;
    font-size: 0.28rem;
    font-weight: bold;
    white-space: nowrap;
  }

  .container > .main{
    margin: 0 auto;
    padding-top: 0.2rem;
    padding-bottom: 0.75rem;
    width: 6.86rem;
  }
  .container > .main > .main-top {
    width: 100%;
   }
  .container > .main > .main-top > div:first-child {
    /*border: 1px solid black;*/
    width: 100%;
    height: 0.65rem;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
  }
  .container > .main > .main-top > div:first-child > p {
    margin: 0;
    padding-left: 0.06rem;
    font-size: 0.46rem;
    font-weight: bold;
    line-height: 0.50rem;
    color: #000000;
    letter-spacing: -0px;
   }
  .container > .main > .main-top > div:first-child > div {
    /*border: 1px solid black;*/
     height: 0.5rem;
     display: flex;
     align-items: flex-end;
   }
  .container > .main > .main-top > div:first-child > div > p {
    margin: 0;
    font-size: 0.26rem;
    line-height: 0.32rem;
    color: #000000;
    letter-spacing: -0px;
  }

  .container > .main > .main-top > .status-sign {
    margin-top: 0.22rem;
    width: 100%;
    height: 0.10rem;
    background-image: linear-gradient(90deg, #FA856E 0%, #195EDB 100%);
  }

  .container > .main > .main-top > .vcar-require {
    padding: 0.3rem 0;
    width: 100%;
    background: #FFFFFF;
    box-shadow: 9px 12px 14px -7px rgba(0,0,0,0.11);
  }
  .container > .main > .main-top > .vcar-require > div > .item {
    margin-top: 0.38rem;
    margin-left: 0.41rem;
    width: 5.54rem;
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-start;
    justify-content: space-between;
  }
  .container > .main > .main-top > .vcar-require > div > .item:first-child {
    margin-top: 0;
  }

  .vcar-require > div > .item > p {
    margin: 0;
    font-size: 0.24rem;
    line-height: 0.33rem;
    letter-spacing: -0px;
    color: #999999;
  }

  .vcar-require > div > .item > .content {
    width: 4.08rem;
    color: #000000;
  }

  .container > .main > .main-bottom {
    margin: 0;
    margin-top: 0.77rem;
    width: 6.86rem;
  }

  .container > .main > .main-bottom > div:first-child {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
  }
  .container > .main > .main-bottom > div:first-child > p {
    margin: 0;
    margin-left: 0.06rem;
    font-size: 0.46rem;
    line-height: 0.5rem;
    color: #000000;
    letter-spacing: -0px;
  }
  .container > .main > .main-bottom > div:first-child > div {
    height: 0.5rem;
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-end;
  }
  .container > .main > .main-bottom > div:first-child > div > p {
    margin: 0;
    font-size: 0.26rem;
    color: #000000;
    letter-spacing: -0px;
  }
  .container > .main > .main-bottom > div:first-child > div > p:last-child {
    margin-left: 0.36rem;
  }

  .container > .main > .main-bottom > .vcar-success {
    margin-top: 0.22rem;
    margin-bottom: 0.43rem;
  }

  .container > .main > .main-bottom > .vcar-success > .vcar-data-1 {
    padding: 0.37rem 0;
    background-image: linear-gradient(90deg, #F64128 0%, #FA856E 100%);
  }
  .vcar-success > .vcar-data-1 > .item {
    margin-top: 0.38rem;
    margin-left: 0.27rem;
    width: 5.39rem;
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-start;
    justify-content: space-between;
  }

  .vcar-success > .vcar-data-1 > .item:first-child {
    margin-top: 0;
  }
  .vcar-success > .vcar-data-1 > .item > p {
    margin: 0;
    font-size: 0.30rem;
    line-height: 0.42rem;
    color: #FFFFFF;
    letter-spacing: -0px;
  }
  .vcar-success > .vcar-data-1 > .item > pre {
    width: 3.8rem;
    margin: 0;
    font-size: 0.30rem;
    line-height: 0.42rem;
    color: #FFFFFF;
    letter-spacing: -0px;
    white-space: pre-wrap;
  }
  .vcar-success > .vcar-data-1 > .item > p:last-child {
    width: 3.8rem;
  }

  .container > .main > .main-bottom > .vcar-success > .vcar-time-consuming {
    margin: 0.23rem 0;
    width: 100%;
    height: 0.4rem;
    display: flex;
    justify-content: flex-end;
  }
  .vcar-success > .vcar-time-consuming > p {
    margin: 0;
    font-size: 0.28rem;
    color: #000000;
    letter-spacing: -0px;
    opacity: 0.49;
  }

  .container > .main > .main-bottom > .vcar-success > .vcar-data-2 {
    padding: 0.37rem 0;
    background-image: linear-gradient(90deg, #195EDB 0%, #2594FE 100%);
  }
  .vcar-success > .vcar-data-2 > .item {
    margin-top: 0.38rem;
    margin-left: 0.27rem;
    max-width: 5.39rem;
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-start;
    justify-content: space-between;
  }

  .vcar-success > .vcar-data-2 > .item:first-child {
    margin-top: 0;
  }
  .vcar-success > .vcar-data-2 > .item > p {
    margin: 0;
    font-size: 0.30rem;
    line-height: 0.42rem;
    color: #FFFFFF;
    letter-spacing: -0px;
  }
  .vcar-success > .vcar-data-2 > .item > p:last-child {
    width: 3.6rem;
  }

  .vcar-success > .vcar-data-2 > .item-2 > p:last-child {
    width: 2.6rem;
  }

  .vcar-ing {
    margin-top: 0.22rem;
    padding-top: 1rem;
    padding-bottom: 0.86rem;
    width: 100%;
    font-size: 0;
    text-align: center;
    background: #FFFFFF;
    box-shadow: 9px 12px 14px -7px rgba(0,0,0,0.11);
  }
  .vcar-ing > img {
    width: 1.65rem;

  }
  .vcar-ing > p{
    margin: 0;
    margin-top: 0.73rem;
    font-size: 0.40rem;
    line-height: 0.56rem;
    color: #979797;
    letter-spacing: -0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Vcar_Result.vue